var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen grid place-content-center"},[_c('h1',{staticClass:"text-4xl"},[_vm._v("under development :v")])])
}]

export { render, staticRenderFns }